import React, {useEffect, useContext} from 'react';
import './App.css';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import Home from "./components/Home";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import ResultsForm from "./components/ResultsForm";
import PatientForm from "./components/PatientForm";
import AdminPanel from "./components/admin/AdminPanel";
import Confirmation from "./components/Confirmation";
import {MachineExport} from "./components/admin/MachineExport";
import PrivatePod from "./components/PrivatePod";
import Login from "./components/admin/Login"; //FC
import PatientCheckIn from "./components/PatientCheckIn";
import {RetrieveConfirmation} from "./components/RetrieveConfirmation";
import {TestManagement} from "./components/admin/TestManagement";
import Alert from "./../src/components/admin/Alert";
import CheckIn from "./components/admin/CheckIn";
import SamplesReport from "./components/admin/SamplesReport";
import WalkinForm from "./components/admin/WalkinForm";
import {WellPlateReport} from "./components/admin/WellPlateReport";
import {BinReceiving} from "./components/admin/BinReceiving";
import {InternalSpecimen} from "./components/admin/InternalSpecimen";
import {Facility} from "./components/admin/Facility";
import {RerunReport} from "./components/admin/RerunReport";
import {BatchReporting} from "./components/admin/BatchReporting";
import {SamplesStatusReport} from "./components/admin/SamplesStatusReport";
import {AccessionApp} from "./components/admin/AccessionApp";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import LoggedOut from "./components/admin/LoggedOut";
import RapidTestManagement from "./components/admin/RapidTestManagement";
// import PodStats from "./components/admin/PodStats";
import Schedules from "./components/admin/Schedules";

import {BatchManagement} from "./components/admin/BatchManagement";
import {AuditLogs} from "./components/admin/AuditLogs";
import {ReconcileLab} from "./components/admin/ReconcileLab";
import {RetrieveReceivingLabel} from "./components/admin/RetrieveReceivingLabel";
import {UserManagement} from "./components/admin/UserManagement";
import {ServicesManagement} from "./components/admin/ServicesManagement";
import {ResultsManagement} from "./components/admin/ResultsManagement";
import {CommunicationTemplates} from "./components/admin/CommunicationTemplates";
import AdminHomePage from "./components/admin/AdminHomePage";
import {CustomFields} from "./components/admin/CustomFields";
import { ReportSettings } from './components/admin/ReportSettings';
import { AuthContext } from './context/AuthContext';
import ForgotPassword from './components/admin/ForgotPassword';
import { PatientManagement } from './components/admin/PatientManagement';
import { PasswordSettings } from './components/admin/PasswordSettings';
import { FakeSampleGenerator } from './components/admin/FakeSampleGenerator';
import { DocumentUpload } from './components/admin/DocumentUpload';
import { BannerManagement } from './components/admin/BannerManagement';

const swal = withReactContent(Swal);

export const CAPTCHA = "6Lc4JUAcAAAAAGPcDlen-26x_KpyZUjY7acuP4Al";

//setting defaults for sweetalert
export let sweetalert = swal.mixin({
    showCloseButton:false, // hide the 'x' at the top of the modal
    confirmButtonColor: '#21212E',      // dark blue
    cancelButtonText: 'Cancel',
    cancelButtonColor: '#808080',       // grey 
    denyButtonColor: '#dc3741',         // standard red
    allowOutsideClick: false,           // enforce user interact with modal buttons
    allowEscapeKey: false,              // enforce user interact with modal buttons
    reverseButtons: true,               // cancel left, confirm right
    showClass: {
        backdrop: 'swal2-noanimation',  // disable backdrop animation
        popup: '',                      // disable popup animation
        icon: '',                       // disable icon animation
    },
    hideClass: {
        popup: '',                     // disable popup fade-out animation
    },
    customClass: {
        container: 'swal-on-top swal2-html-container'
    }
});

function App(){
    const userContext = useContext(AuthContext);

    useEffect(()=>{
        document.title = "Streamline"
    },[]);// runs on load

    const getNavRoute = (comp:any)=>{
        return(
            <React.Fragment>
                <Nav/>
                {comp}
                <Footer/>
            </React.Fragment>
        )
    }

    const getAdminNavRoute = (comp:any, props)=>{
        document.body.style.backgroundColor = 'white'
        return (
            <> 
            { userContext && 
                <React.Fragment>
                    <AdminPanel {...props} />
                    {comp}
                </React.Fragment>
            }
            </>
        )
    }

    const getLoginRoute = (comp:any)=>{
        return (
            <React.Fragment>
                {comp}
            </React.Fragment>
        )
    }
    return (
        <BrowserRouter>
            <React.Fragment>
                <Switch>
                    <Route path="/" render={(props) => getNavRoute(<Home />)} exact />
                    <Route path="/private" render={(props) => getNavRoute(<PrivatePod />)} exact />
                    <Route path="/appointment" render={(props) => getNavRoute(<PatientForm />)} exact />
                    <Route path="/results" render={(props) => getNavRoute(<ResultsForm />)} exact />
                    <Route path="/admin" render={(props)=> getAdminNavRoute(<AdminHomePage />, props)} exact /> 
                    <Route path="/admin/CheckIn" render={(props) => getAdminNavRoute(<CheckIn />, props)} exact />
                    <Route path="/admin/WalkinForm" render={(props) => getAdminNavRoute(<WalkinForm />, props)} exact />
                    <Route path="/admin/RapidTestManagement" render={(props) => getAdminNavRoute(<RapidTestManagement />, props)} exact />
                    {/* <Route path="/admin/Schedules" render={(props) => getAdminNavRoute(<PodStats />)} exact /> */}
                    <Route path="/admin/Schedules" render={(props) => getAdminNavRoute(<Schedules />, props)} exact />

                    <Route path="/admin/Alert" render={(props) => getAdminNavRoute(<Alert />, props)} exact />
                    <Route path="/admin/Samples" render={(props) => getAdminNavRoute(<SamplesReport />, props)} exact />
                    <Route path="/admin/InternalSampleGenerator" render={(props) => getAdminNavRoute(<FakeSampleGenerator />, props)} exact />
                    {/* <Route path="/admin/Accession" render={(props) => getAdminNavRoute(<WellPlateReport />, props)} exact /> */}
                    <Route path="/admin/SpecimenLabel" render={(props) => getAdminNavRoute(<InternalSpecimen />, props)} exact />
                    <Route path="/admin/MachineExport" render={(props) => getAdminNavRoute(<MachineExport />, props)} exact />
                    <Route path="/admin/RerunReport" render={(props) => getAdminNavRoute(<RerunReport />, props)} exact />
                    <Route path="/admin/BatchReporting" render={(props) => getAdminNavRoute(<BatchReporting />, props)} exact />
                    <Route path="/admin/AccessionApp" render={(props) => getAdminNavRoute(<AccessionApp />, props)} exact />
                    <Route path="/admin/BatchManagement" render={(props) => getAdminNavRoute(<BatchManagement />, props)} exact />
                    <Route path="/admin/AuditLogs" render={(props) => getAdminNavRoute(<AuditLogs />, props)} exact />
                    <Route path="/admin/ReconcileReport" render={(props) => getAdminNavRoute(<SamplesStatusReport />, props)} exact />
                    <Route path="/admin/ReconcileLab" render={(props) => getAdminNavRoute(<ReconcileLab />, props)} exact />
                    <Route path="/admin/BinReceiving" render={(props) => getAdminNavRoute(<BinReceiving />, props)} exact />
                    <Route path="/admin/RetrieveReceivingLabel" render={(props) => getAdminNavRoute(<RetrieveReceivingLabel />, props)} exact />
                    <Route path="/admin/Facility" render={(props) => getAdminNavRoute(<Facility />, props)} exact />
                    <Route path="/admin/UserManagement" render={(props) => getAdminNavRoute(<UserManagement />, props)} exact />
                    <Route path="/admin/PatientManagement" render={(props) => getAdminNavRoute(<PatientManagement />, props)} exact />
                    <Route path="/admin/TestManagement" render={(props) => getAdminNavRoute(<TestManagement />, props)} exact />
                    <Route path="/admin/ServicesManagement" render={(props) => getAdminNavRoute(<ServicesManagement />, props)} exact />
                    <Route path="/admin/CustomFields" render={(props) =>  getAdminNavRoute(<CustomFields/>, props)} exact/>
                    <Route path="/admin/ResultsManagement" render={(props) =>  getAdminNavRoute(<ResultsManagement/>, props)} exact/>
                    <Route path="/admin/BannerManagement" render={(props) =>  getAdminNavRoute(<BannerManagement/>, props)} exact/>
                    <Route path="/admin/CommunicationTemplates" render={(props) => getAdminNavRoute(<CommunicationTemplates />, props)} exact />
                    <Route path="/admin/ReportSettings" render={(props) => getAdminNavRoute(<ReportSettings />, props)} exact />
                    <Route path="/admin/PasswordRequirements" render={(props)=> getAdminNavRoute(<PasswordSettings />, props)} exact />
                    <Route path="/admin/FileManagement" render={(props)=> getAdminNavRoute(<DocumentUpload />, props)} exact />
                    <Route path="/confirmation" render={(props) => getNavRoute(<Confirmation />)} exact />
                    <Route path="/checkin" render={(props) => <PatientCheckIn />} exact />
                    <Route path="/retrieve" render={(props) => getNavRoute(<RetrieveConfirmation />)} exact />
                    <Route path="/logout" render={(props)=> getNavRoute(<LoggedOut /> )} exact />
                    <Route path="/loggedout" render={(props) => getNavRoute(<LoggedOut />)} exact />
                    <Route path="/login" render={(props)=> getLoginRoute(<Login form_action={'login'} />) } exact />
                    <Route path="/forgotPassword" render={(props) => getLoginRoute(<ForgotPassword />)} exact/>
                    <Route path="/__/auth/:action" render={(props)=> getLoginRoute(<Login form_action={props.match.params.action} />)} />
                    <Redirect to={"/admin"} />
                </Switch>
            </React.Fragment>
        </BrowserRouter>);
}

export default App;
